import { render } from "./NewSurvey.vue?vue&type=template&id=fac753ca"
import script from "./NewSurvey.vue?vue&type=script&lang=js"
export * from "./NewSurvey.vue?vue&type=script&lang=js"

import "./NewSurvey.vue?vue&type=style&index=0&id=fac753ca&scooped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__